module.exports = __webpack_public_path__ + "static/library-69cca2b113ebf56ceefc5012013a4eb0.png";